// General
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ViewListing.css';
import bt from '../../components/commonStyle.css';
import {
  Button,
  Grid,
  Row,
  Col
} from 'react-bootstrap';
import cx from 'classnames';
import * as FontAwesome from 'react-icons/lib/fa';
// Components
import Photos from '../../components/ViewListing/Photos';
import ListingIntro from '../../components/ViewListing/ListingIntro';
import Calendar from '../../components/ViewListing/Calendar';
import BookAViewing from '../../components/ViewListing/BookAViewing/BookAViewing';
import ListingDetails from '../../components/ViewListing/ListingDetails';
//import Reviews from '../../components/ViewListing/Reviews';
import LocationMap from '../../components/ViewListing/LocationMap';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';
//import AvailabilityCalendar from '../../components/ViewListing/AvailabilityCalendar';
//import StarRating from '../../components/StarRating';
import CurrencyConverter from '../../components/CurrencyConverter';
import BookingModal from '../../components/ViewListing/BookingModal';
//import SimilarListings from '../../components/ViewListing/SimilarListings';
import WishListIcon from '../../components/WishListIcon';


// Graphql
import BlockedDatesQuery from './BlockedDates.graphql';
import ListingDataQuery from './getListingData.graphql';
//import MoreReviewsQuery from './MoreReviews.graphql';
//import SimilarListsQuery from './getSimilarListing.graphql';
import AutoAffix from 'react-overlays/lib/AutoAffix';

// Helpers
import { isMobileDevice } from '../../helpers/isMobileDevice';

// ES6 Imports
import Scroll from 'react-scroll'; // Imports all Mixins

// Locale
import messages from '../../locale/messages';

//Action
import { openBookingModal } from '../../actions/BookingModal/modalActions';
import { openSocialShareModal } from '../../actions/modalActions';

import { url } from '../../config';

//Images
import ShareImage from '../../../public/SiteImages/share-alt.svg';
import BgImage from '../../../public/SiteImages/otherPageBG.png'
import HomeIcon from '../../../public/SiteImages/schreibtisch.svg';

// Or Access Link,Element,etc as follows
let Link = Scroll.Link;
let Element = Scroll.Element;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;
var durationFn = function (deltaTop) {
  return deltaTop;
};
class ViewListing extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    listId: PropTypes.number.isRequired,
    preview: PropTypes.bool,
    isAdmin: PropTypes.bool,
    account: PropTypes.shape({
      userId: PropTypes.string,
      userBanStatus: PropTypes.number,
    }),
    ListingBlockedDates: PropTypes.shape({
      loading: PropTypes.bool,
      UserListing: PropTypes.shape({
        blockedDates: PropTypes.array
      })
    }),
    getListingData: PropTypes.shape({
      loading: PropTypes.bool,
      UserListing: PropTypes.object
    }),
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    /* similarListsData: PropTypes.shape({
      loading: PropTypes.bool,
      getSimilarListing: PropTypes.array
    }), */
    openBookingModal: PropTypes.func,
  };
  static defaultProps = {
    getListingData: {
      loading: false,
      UserListing: {
        userId: null
      }
    },
    ListingBlockedDates: {
      loading: true,
      UserListing: {
        blockedDates: []
      }
    },
    account: {
      userId: null,
      userBanStatus: 0,
    },
    isAdmin: false,
    guests: 1
  }
  render() {
    const { listId, title, getListingData: { loading, UserListing }, preview, openSocialShareModal } = this.props;
    const { projectTicketmaster } = this.props;
    const { ListingBlockedDates } = this.props;
    const { formatMessage } = this.props.intl;
    //const { listReviewsData } = this.props;
    const { openBookingModal, baseCurrency } = this.props;
    const { account: { userId, userBanStatus }, isAdmin } = this.props;
    const { lat, lng, startDate, endDate, guests, useFreeTrial/* , similarListsData, similarListsData: { getSimilarListing } */ } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const smallDevice = isMobileDevice();/* window.matchMedia('(max-width: ' + (640 * window.devicePixelRatio) + 'px)').matches */

    let basePriceValue = UserListing && UserListing.listingData && UserListing.listingData.basePrice ? UserListing.listingData.basePrice : 0;
    let currencyValue = UserListing && UserListing.listingData && UserListing.listingData.currency ? UserListing.listingData.currency : "GBP";
    let personCapacity = UserListing && UserListing.personCapacity;

    let workSpaceLabel = personCapacity > 1 ? formatMessage(messages.workSpaces) : formatMessage(messages.workSpace);
    if (isBrowser && loading && !UserListing) {
      return <Loader type="text" />
    }
    let isHost = false;
    if (UserListing) {
      if (userId && userId === UserListing.userId) {
        isHost = true;
      } else if (isAdmin) {
        isHost = true;
      }
    }
    if (preview && !isHost) {
      return <NotFound title={title} />
    }
    if (!loading && !UserListing) {
      return <NotFound title={title} />
    }

    let reviewsCount = UserListing.reviewsCount;
    let reviewsStarRating = UserListing.reviewsStarRating ? UserListing.reviewsStarRating : 0;
    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount);
    }
    let isListOwner = UserListing && UserListing.isListOwner;
    let wishListStatus = UserListing && UserListing.wishListStatus;

    let isTransportLinks = UserListing.userTransportLinks.some((item) => item.listsettings.isEnable == '1');
    let isInTheArea = UserListing.userInTheArea.some((item) => item.listsettings.isEnable == '1');

    return (
      <div className={s.root}>
        <div className={s.bgImageListing} style={{ backgroundImage: `url(${BgImage})` }} />
        <div className={s.container}>
          {
            UserListing && <div className={s.pageContainer}>
              <Element name="test1" className="element">
                <Grid fluid>
                  <Row className={cx(s.pageContent)}>
                    <Col xs={12} sm={12} md={8} lg={8} className={s.noPaddingResponsive}>
                      <Row>
                        <div className={s.stickyContainer}>
                          <AutoAffix viewportOffsetTop={0} container={this} affixClassName={s.showAffix}>
                            <div className={cx(s.zPanel, s.panelDefault)}>
                              <div className={cx("stickHeader", s.viewHeader)}>
                                <div className={s.headerNav}>
                                  <div className={s.textColor}>
                                    <ul className={cx('list-inline', s.stickyMenu)}>
                                      <li>
                                        <Link className={cx(s.textList)} activeClass={s.active} to="test1" spy={true} smooth={true} offset={-50} duration={800} onSetActive={this.handleSetActive}>
                                          <FormattedMessage {...messages.overview} />
                                        </Link>
                                      </li>
                                      {/* <li>
                                        <Link className={cx(s.textList)} activeClass={s.active} to="test2" spy={true} smooth={true} offset={-80} duration={800} onSetActive={this.handleSetActive}>
                                          <FormattedMessage {...messages.reviews} />
                                        </Link>
                                      </li>
                                      <li>
                                        <Link className={cx(s.textList)} activeClass={s.active} to="test3" spy={true} smooth={true} offset={-70} duration={800} onSetActive={this.handleSetActive}>
                                          <FormattedMessage {...messages.theHost} />
                                        </Link>
                                      </li> */}
                                      <li>
                                        <Link className={cx(s.textList)} activeClass={s.active} to="test4" spy={true} smooth={true} offset={-70} duration={800} onSetActive={this.handleSetActive}>
                                          <FormattedMessage {...messages.location} />
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </AutoAffix>
                        </div>
                        <div>
                          <Grid fluid>
                            <Row>
                              <Col xs={12} sm={12} md={12} lg={12}>
                                <Photos data={UserListing} loading={loading} />
                              </Col>
                            </Row>
                          </Grid>
                        </div>
                        <Grid fluid className={cx(s.horizontalLineThrough, s.noBorder, s.listItemMarginTop)}>
                          <ListingDetails
                            data={UserListing}
                            isHost={isHost}
                            userBanStatus={userBanStatus}
                            urlParameters={{ listTitle: UserListing.title, startDate, endDate, guests }}
                            id={UserListing.id}
                            userId={UserListing.userId}
                            hostEmail={UserListing.user.email}
                            personCapacity={UserListing.personCapacity}
                            city={UserListing.city}
                            profile={UserListing.user.profile || undefined}
                            blockedDates={
                              ListingBlockedDates.UserListing != null ?
                                ListingBlockedDates.UserListing.blockedDates : undefined
                            }
                            country={UserListing.country}
                            listingData={UserListing.listingData || undefined}
                          />
                        </Grid>
                        {/* <Grid fluid className={'availabilityMobile'}>
                          <AvailabilityCalendar
                            listId={listId}
                            smallDevice={smallDevice}
                            loading={ListingBlockedDates.loading}
                            blockedDates={
                              ListingBlockedDates.UserListing != null ?
                                ListingBlockedDates.UserListing.blockedDates : undefined
                            }
                            isHotDesking={UserListing.isHotDesking}
                            isOpenOnWeekends={UserListing.isOpenOnWeekends}
                            freeTrialDays={UserListing.freeTrialDays}
                            guests={guests}
                            listingData={UserListing.listingData || undefined}
                            country={UserListing.country}
                          />
                        </Grid> */}
                        {/* <Element name="test2" className="element">
                          <Grid fluid>
                            <Reviews
                              reviewsCount={UserListing.reviewsCount}
                              reviewsStarRating={UserListing.reviewsStarRating}
                              data={listReviewsData}
                              listId={listId}
                            />
                          </Grid>
                        </Element> */}
                      </Row>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} className={cx(s.positionSticky, s.paddingTopCalendar, s.zIndex)}>
                      <div className={cx('hidden-xs', 'hidden-sm')}>
                        {/* <div>
                          <div className={s.saveButtonSection}>
                            {
                              <div className={cx(s.displayInlineBlock, s.shareBtnSection)} onClick={openSocialShareModal}>
                                <span>
                                  <img src={ShareImage} alt={'shareImage'} className={s.shareIcon} />
                                </span>
                                <span><FormattedMessage {...messages.shareLabel} /></span>
                              </div>
                            }
                            {
                              !isListOwner && !loading && UserListing && <div className={cx(s.displayInlineBlock)}>
                                <WishListIcon type="button" listId={UserListing.id} isChecked={wishListStatus} />
                              </div>
                            }
                          </div>
                        </div> */}
                        <div>
                          <ListingIntro 
                            data={UserListing}
                            reviewsCount={UserListing.reviewsCount}
                            reviewsStarRating={reviewsStarRating}
                            personCapacity={UserListing.personCapacity}
                          />
                        </div>
                      </div>
                      {
                        UserListing && <div className={cx(s.responsiveNopadding, 'hidden-xs hidden-sm')}>
                          <Calendar
                            id={UserListing.id}
                            loading={ListingBlockedDates.loading}
                            projectTicketmaster={projectTicketmaster}
                            blockedDates={
                              ListingBlockedDates.UserListing != null ?
                                ListingBlockedDates.UserListing.blockedDates : undefined
                            }
                            personCapacity={UserListing.personCapacity}
                            listingData={UserListing.listingData || undefined}
                            isHost={isHost}
                            bookingType={UserListing.bookingType}
                            userBanStatus={userBanStatus}
                            startDate={startDate}
                            endDate={endDate}
                            isHotDesking={UserListing.isHotDesking}
                            isOpenOnWeekends={UserListing.isOpenOnWeekends}
                            isSample={UserListing.isSample}
                            freeTrialDays={UserListing.freeTrialDays}
                            reviewsCount={UserListing.reviewsCount}
                            reviewsStarRating={reviewsStarRating}
                            guests={guests}
                            useFreeTrial={useFreeTrial}
                            country={UserListing.country}
                            profile={UserListing.user.profile || undefined}
                            smallDevice={smallDevice}
                          />
                        </div>
                      }
                      {
                        UserListing && <div className={cx(s.responsiveNopadding, 'hidden-xs hidden-sm')}>
                          <BookAViewing
                            id={UserListing.id}
                            userId={UserListing.userId}
                            hostEmail={UserListing.user.email}
                            city={UserListing.city}
                            profile={UserListing.user.profile || undefined}
                            country={UserListing.country}
                            smallDevice={smallDevice}
                          />
                        </div>
                      }
                      {/* 
                        !smallDevice && loading && <div className={cx(s.webDevice, s.responsiveNopadding, 'hidden-xs hidden-sm')}>
                          <Calendar
                            id={UserListing.id}
                            loading={ListingBlockedDates.loading}
                            projectTicketmaster={projectTicketmaster}
                            blockedDates={
                              ListingBlockedDates.UserListing != null ?
                                ListingBlockedDates.UserListing.blockedDates : undefined
                            }
                            personCapacity={UserListing.personCapacity}
                            listingData={UserListing.listingData || undefined}
                            isHost={isHost}
                            bookingType={UserListing.bookingType}
                            userBanStatus={userBanStatus}
                            startDate={startDate}
                            endDate={endDate}
                            isHotDesking={UserListing.isHotDesking}
                            isOpenOnWeekends={UserListing.isOpenOnWeekends}
                            isSample={UserListing.isSample}
                            freeTrialDays={UserListing.freeTrialDays}
                            reviewsCount={UserListing.reviewsCount}
                            reviewsStarRating={reviewsStarRating}
                            guests={guests}
                            country={UserListing.country}
                            profile={UserListing.user.profile || undefined}
                            smallDevice={smallDevice}
                          />
                        </div>
                       */}
                    </Col>
                  </Row>
                  <div>
                    <Element name="test4" className="element">
                      <Grid fluid className={cx(s.paddingTop2, s.pageContent, s.spaceTop3)}>
                        <div>
                          <Col xs={12} sm={12} md={8} lg={8} className={s.noPaddingResponsive}>
                            <LocationMap data={UserListing} />
                          </Col>
                          <Col xs={12} sm={12} md={4} lg={4} className={s.noPaddingResponsive}>
                          {isTransportLinks && 
                          <div>
                              <h3 className={s.transportTitle}>
                                <FormattedMessage {...messages.transportLinksLabel} />
                              </h3>
                              <div className={s.displayTable}>
                                  <div className={s.displayTableRow}>
                                    <div className={cx(s.displayTableCell)}>
                                    {
                                      UserListing.userTransportLinks.map((item, key) => {
                                        if (item.listsettings.isEnable === "1") {
                                          return (
                                            <span style={{whiteSpace: 'pre'}}>
                                              { item.listsettings.image &&
                                              <span>
                                                <img src={url + '/images/amenities/' + item.listsettings.image} className={s.inTheAreaIcon} />
                                              </span>
                                              }
                                              <span className={s.inTheAreaLabel}>
                                                {item.listsettings.itemName}
                                              </span>
                                            </span>
                                          )
                                        }
                                      })
                                    }
                                    </div>
                                  </div>
                              </div>
                            </div>}
                            {isInTheArea && <div>
                              <div>
                                <p className={cx(s.transportTitle, s.spaceTop3, s.space1)}><FormattedMessage {...messages.inTheArea} /></p>
                                <div className={s.displayTable}>
                                  <div className={s.displayTableRow}>
                                    <div className={cx(s.displayTableCell)}>
                                    {
                                      UserListing.userInTheArea.map((item, key) => {
                                        if (item.listsettings.isEnable === "1") {
                                          return (
                                            <span style={{whiteSpace: 'pre'}}>
                                              { item.listsettings.image &&
                                              <span>
                                                <img src={url + '/images/amenities/' + item.listsettings.image} className={s.inTheAreaIcon} />
                                              </span>
                                              }
                                              <span className={s.inTheAreaLabel}>
                                                {item.listsettings.itemName}
                                              </span>
                                            </span>
                                          )
                                        }
                                      })
                                    }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}
                          </Col>
                        </div>
                      </Grid>
                    </Element>
                  </div>
                  {/* {
                    similarListsData && similarListsData.getSimilarListing && similarListsData.getSimilarListing.length > 0 &&
                    <Grid fluid className={cx(s.space2, s.noPaddingMobile,
                      s.pageContent, s.similarPadding)}>
                      <Row className={cx(s.space3,
                        s.sliderMargin, 'similarListing', s.similarPadding)}>
                        <Col xs={12} sm={12} md={12} lg={12}
                          className={cx(s.spaceTop2, s.space2, s.similarPaddingText)}>
                          <h2 className={cx(s.sectionTitleText, s.space2)}><FormattedMessage {...messages.similarListings} /></h2>
                        </Col>
                        <SimilarListings data={similarListsData.getSimilarListing} />
                      </Row>
                    </Grid>
                  } */}
                </Grid>
              </Element>
            </div>
          }
          <div className={cx(s.stickyBookButton, 'visible-sm visible-xs')}>
            <div className={cx(s.filtersFooter)}>
              <div className={s.filtersContainer}>
                <Row className={s.footerContainer}>
                  <div className={cx(s.displayTable)}>
                    <div className={cx(s.smSpace, s.displayTableCell, s.displayBlockMobile)}>
                      <div className={(s.bookItPriceAmount)}>
                        {
                          UserListing && UserListing.bookingType === "instant" && <span>
                            <FontAwesome.FaBolt className={s.instantIcon} />
                          </span>
                        }
                        <div className={s.bookItPrice}>
                          <CurrencyConverter
                            from={currencyValue || baseCurrency}
                            amount={basePriceValue || 0}
                            className={s.bookItPrice}
                          />
                        </div>
                        <span className={s.bookItNight}>{' '}<FormattedMessage {...messages.searchListingDayLabel} /></span>
                      </div>
                      {/* <div>
                        <div className={s.reviewSection}>
                          <StarRating name={'review'} value={starRatingValue} />
                        </div>
                        <div>
                          <span >{reviewsCount > 0 && <span>{reviewsCount}{' '}{reviewsCount > 1 ? <FormattedMessage {...messages.reviews} /> : <FormattedMessage {...messages.review} />}</span>}</span>
                        </div>
                      </div> */}
                      <div className={cx(s.displayTable)}>
                        <div className={s.displayTableRow}>
                          <div className={cx(s.displayTableCell, s.listingIntroWidth, s.responsiveListIngIntro)}>
                            <div className={cx(s.displayTable)}>
                              <div className={s.displayTableRow}>
                                <div className={cx(s.displayTableCellIcon, 'overviewIconRtl')}>
                                  <img src={HomeIcon} className={s.overviewIcon} alt={'Room'} />
                                </div>
                                <div className={cx(s.displayTableCell, s.introTextPadding)}>
                                  <div className={cx(s.iconText)}>{personCapacity} {workSpaceLabel}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className={cx(s.displayTableCell, s.responsiveListIngIntro)}>
                            <div className={cx(s.displayTable, s.tableMarginTop)}>
                              <div className={s.displayTableRow}>
                                <div className={cx(s.displayTableCellIcon, 'overviewIconRtl')}>
                                  <img src={StarIcon} className={s.overviewIcon} alt={'starIcon'} />
                                </div>
                                <div className={cx(s.displayTableCell, s.introTextPadding)}>
                                  <div className={cx(s.iconText)}>
                                    <span className={s.reviewCountText}>4.2</span>
                                    {' '}
                                    <span className={cx(s.textInline, s.reviewText)}>
                                      ({reviewsCount + ' '}{reviewsCount > 1 ? formatMessage(messages.reviews) : formatMessage(messages.review)})
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className={cx(s.displayTableCell, s.displayBlockMobile, s.spaceTop2)}>
                      <BookingModal
                        id={UserListing.id}
                        loading={ListingBlockedDates.loading}
                        projectTicketmaster={projectTicketmaster}
                        blockedDates={
                          ListingBlockedDates.UserListing != null ?
                            ListingBlockedDates.UserListing.blockedDates : undefined
                        }
                        personCapacity={UserListing.personCapacity}
                        listingData={UserListing.listingData || undefined}
                        isHost={isHost}
                        bookingType={UserListing.bookingType}
                        isHotDesking={UserListing.isHotDesking}
                        isOpenOnWeekends={UserListing.isOpenOnWeekends}
                        isSample={UserListing.isSample}
                        freeTrialDays={UserListing.freeTrialDays}
                        reviewsCount={UserListing.reviewsCount}
                        reviewsStarRating={reviewsStarRating}
                        guests={guests}
                        useFreeTrial={useFreeTrial}
                        country={UserListing.country}
                        profile={UserListing.user.profile || undefined}
                        smallDevice={smallDevice}
                      />
                      <Button className={cx(s.btn, bt.btnPrimary, s.fullWidth)} onClick={openBookingModal}>
                        <FormattedMessage {...messages.bookNow} />
                      </Button>
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapState = (state) => ({
  account: state.account.data,
  isAdmin: state.runtime.isAdminAuthenticated
});
const mapDispatch = {
  openBookingModal,
  openSocialShareModal
};
export default compose(injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  graphql(ListingDataQuery,
    {
      name: 'getListingData',
      options: (props) => ({
        variables: {
          listId: props.listId,
          preview: props.preview,
        },
        fetchPolicy: 'network-only',
        ssr: true
      })
    }
  ),
  graphql(BlockedDatesQuery,
    {
      name: 'ListingBlockedDates',
      options: (props) => ({
        variables: {
          listId: props.listId,
          preview: props.preview,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  )/* ,
  graphql(MoreReviewsQuery,
    {
      name: 'listReviewsData',
      options: (props) => ({
        variables: {
          listId: props.listId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ) *//* ,
  graphql(SimilarListsQuery,
    {
      name: 'similarListsData',
      options: (props) => ({
        variables: {
          listId: props.listId,
          lat: props.lat,
          lng: props.lng
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ) */
)(ViewListing);


// WEBPACK FOOTER //
// src/routes/viewListing/ViewListing.js